import { Colors, Services } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

function renderTitle(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value,
        icon: icons.subtitles,
        color: Colors.grey,
        label: this.getTranslate(`${Services.credentials}.labels.title`),
        service: Services.credentials,
        copy: true
      }
    }
  )
}

function renderUsername(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value.records?.username,
        icon: icons.person,
        color: Colors.grey,
        label: this.getTranslate(`${Services.credentials}.labels.records.username`),
        copy: true
      }
    }
  )
}

function renderInfo(h) {
  return h(
    'div',
    {
      class: `${Services.credentials}-item__info`
    },
    [
      renderTitle.call(this, h),
      renderUsername.call(this, h)
    ]
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        ['service-template-item']: true,
        ['hover-parent hover-parent--opacity']: this.viewport.breakpoint.mdUp,
        [`${Services.credentials}-item`]: true
      }
    },
    [
      renderInfo.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
